import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import withAuth from '../components/authHOC';

import StatementTable from '../components/StatementTable';


const StatementPage = () => {


  return (
    <Container fluid id='users-container'>
      <StatementTable/>

    </Container>
  )
}

export default withAuth (StatementPage, ['admin', 'agent'])
